<app-modal-container
  class="green-scroll"
  [bigSize]="false"
  [titleDirection]="'start'"
  [buttons]="modalButtons"
  (dismissButtonClicked)="close(false)"
  (closeButtonClicked)="close(false)"
  (applyButtonClicked)="confirm()"
  (lowerLeftButtonClicked)="addMetricGroupClicked()">
  <div class="flex flex-col gap-[1.5rem]">
    <div class="bold600 title-2 flex justify-start items-center gap-[0.2rem]">
      <span class="black-12">Tracked metrics for</span>
      <span class="main-8">{{ selectedCompanyWrapper.company.name }}</span>
    </div>
    <div class="flex flex-col gap-[1rem]">
      <div class="w-full bg-black-1 br-0p5">
        <div class="flex gap-[0.5rem] align-items-center p-[0.5rem]">
          <span class="font-3 bold500 w-24">
            Copy from
          </span>
          <app-selector
            [attr.data-qa]="'kpi-update-metrics-visibility-copy-from-company-input'"
            class="w-full"
            [data]="companiesForCopy"
            [defaultPlaceholder]="'Select company'"
            (itemEmitter)="copyFromCompany($event)"
          />
        </div>
      </div>
      @for (isEnabled of ([true, false]); track isEnabled) {
        <div
          *ngIf="metricGroupForm"
          class="max-height-35vh overflow-auto width-35"
          [formGroup]="metricGroupForm">
          <div
            data-qa="container-in-reorder-modal"
            formArrayName="groups">
            <!-- We show enabled header only if there is at least one selected metric group.-->
            <!-- We show disabled header always.-->
            <div
              *ngIf="!isEnabled || (metricGroupForm.value.groups.length > 0 && metricGroupForm.value.groups[0].isSelected)"
              cdkScrollable
              class="table-fms max-height-35vh">
              <table
                cdkDropList
                id="{{isEnabled ? enabledListId : disabledListId}}">
                <thead>
                <tr>
                  <th colspan="3">{{ isEnabled ? 'Enabled' : 'Disabled' }}</th>
                  <th class="fix-w-16p75"></th>
                  <th>Metrics</th>
                  <th class="fix-w-2p5">Data</th>
                </tr>
                </thead>
                <tbody>
                  @for (group of metricGroupForm.controls.groups.controls; track group.controls.name) {
                    @if (group.value.isSelected === isEnabled) {
                      <tr
                        cdkDrag
                        cdkDragPreviewClass="cdk-drag-preview"
                        [formGroupName]="$index"
                        [attr.data-qa]="'reorder-group-' + group.value.name"
                        [cdkDragData]="group"
                        (cdkDragDropped)="drop($event)">
                        <td>
                          <app-all-icons
                            [attr.data-qa]="'kpi-update-metrics-visibility-drag-icon-' + group.value.name"
                            cdkDragHandle
                            [style.cursor]="'pointer'"
                            [iconNameAndStyling]="'two-lines-six-dots.svg;icon-size-1p25'"
                          />
                        </td>
                        <td>
                          <app-table-group-icon
                            [attr.data-qa]="'show-grouping' + group.value.name"
                            [opened]="group.value.isExpanded"
                            (click)="group.controls.isExpanded.patchValue(!group.value.isExpanded)"
                          />
                        </td>
                        <td>
                          <app-checkbox
                            [attr.data-qa]="'kpi-update-metrics-visibility-is-selected-checkbox-' + group.value.name"
                            formControlName="isSelected"
                            [minus]="group.value.visibleMetricsAmount > 0 && group.value.visibleMetricsAmount !== group.value.metrics.length"
                            (checkBoxClicked)="toggleMetricGroupVisibility(group,!$event)"
                          />
                        </td>
                        <td>
                          <div class="flex justify-start gap-[1rem] align-items-center">
                        <span [attr.data-qa]="'kpi-update-metrics-visibility-group-name-' + group.value.name">
                          {{ group.value.name | linkShort : 40 }}
                        </span>
                            <app-button
                              *ngIf="group.value.role === MetricGroupRole.CUSTOM"
                              [attr.data-qa]="'kpi-update-metrics-edit-custom-group-' + group.value.name"
                              [size]="'xxxsmall'"
                              [type]="'light-grey'"
                              [iconName]="'edit.svg'"
                              (buttonClick)="addMetricGroupClicked(group.value.uuid)">
                              Edit
                            </app-button>
                          </div>
                        </td>
                        <td>
                          <div
                            [attr.data-qa]="'kpi-update-metrics-visibility-group-show-metrics-' + group.value.name"
                            class="flex justify-start gap-[0.2rem]">
                         <span
                           [attr.data-qa]="'kpi-update-metrics-visibility-visible-metric-amount-' + group.value.name"
                           class="black-12">{{ group.value.visibleMetricsAmount }}
                         </span>
                            <span class="black-7">of</span>
                            <span
                              [attr.data-qa]="'kpi-update-metrics-visibility-total-metric-amount-' + group.value.name"
                              class="black-7">{{ group.value.metrics.length }}
                         </span>
                          </div>
                        </td>
                        <td>
                          <div class="flex justify-start">
                            @if (group.value.isMetricDataProvided) {
                              <app-all-icons [iconNameAndStyling]="'check.svg; icon-size-1p25'"/>
                            }
                          </div>
                        </td>
                      </tr>
                      @if (group.value.isExpanded) {
                        @for (metric of group.controls.metrics.controls; track metric.value.uuid) {
                          <tr>
                            <td colspan="3"></td>
                            <td colspan="100%">
                              <div
                                [attr.data-qa]="'kpi-update-metrics-visibility-metric-wrapper-' + metric.value.name"
                                class="flex justify-start gap-[0.5rem] align-items-center">
                                <app-checkbox
                                  [attr.data-qa]="'kpi-update-metrics-visibility-metric-toggle-visibility-' + metric.value.name"
                                  [checked]="!metric.value.companyMetrics[0].isHidden"
                                  (checkBoxClicked)="toggleMetricVisibility(group, metric, !$event)"
                                />
                                <app-all-icons
                                  [attr.data-qa]="metric.value.dataProps"
                                  class="black-6"
                                  [iconNameAndStyling]="metric.value.dataProps.iconNameAndStylingLeft"/>
                                <span
                                  [attr.data-qa]="'kpi-update-metrics-visibility-metric-name-' + metric.value.name">{{ metric.value.name }}</span>
                              </div>
                            </td>
                          </tr>
                        }
                      }
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

</app-modal-container>

@if (showCreateMetricGroupModal) {
  <app-modal-custom-metric-group-crud
    data-qa="modal-create-new-metric-group"
    [modalType]="selectedMetricGroupForCrud.uuid ? 'update' : 'create'"
    [group]="selectedMetricGroupForCrud"
    [allGroups]="[]"
    (closeEmitter)="closeNewMetricGroupModal()"
    (confirmEmitter)="proceedMetricGroupAfterCreateOrUpdate($event)"
    (deleteMetricGroup)="deleteMetricGroup()"
  />
}
